import React, { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Alert } from 'reactstrap'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'

const CREATE_INCIDENT_PARTY_REPRESENTATIVE = gql`
  mutation CreateIncidentPartyRepresentative($input: CreateIncidentPartyRepresentativeMutationInput!) {
    createIncidentPartyRepresentative(input: $input) {
      ok
      representative {
        id
    }
      errors {
        field
        messages
      }
    }
  }
`

const AddRepresentativeModal = ({ isOpen, toggle, refetchRepresentatives, onCreate }) => {
    const [newRepresentative, setNewRepresentative] = useState({
        name: '',
        businessName: '',
        phone: '',
        email: '',
        address: '',
        role: '',
    })
    const [representativeError, setRepresentativeError] = useState(null)
    const [createRepresentative, { loading: creatingRepresentative }] = useMutation(CREATE_INCIDENT_PARTY_REPRESENTATIVE)

    const handleCreateRepresentative = async () => {
        setRepresentativeError(null)
        if (!newRepresentative.name || !newRepresentative.businessName) {
            setRepresentativeError('Name and Business Name are required.')
            return
        }
        const input = { ...newRepresentative }
        try {
            const { data } = await createRepresentative({ variables: { input } })
            if (data?.createIncidentPartyRepresentative?.ok) {
                const createdRepresentative = {
                    id: data.createIncidentPartyRepresentative.representative.id,
                    name: newRepresentative.name,
                }
                await refetchRepresentatives()
                if (onCreate) onCreate(createdRepresentative)
                toggle()
                setNewRepresentative({
                    name: '',
                    businessName: '',
                    phone: '',
                    email: '',
                    address: '',
                    role: '',
                })
            } else if (data?.createIncidentPartyRepresentative?.errors?.length) {
                setRepresentativeError(data.createIncidentPartyRepresentative.errors[0].messages[0])
            }
        } catch (e) {
            setRepresentativeError(e.message)
        }
    }

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>Create Representative</ModalHeader>
            <ModalBody>
                {representativeError && <Alert color="danger">{representativeError}</Alert>}
                <FormGroup>
                    <Label for="repName">Name*</Label>
                    <Input
                        id="repName"
                        value={newRepresentative.name}
                        onChange={e => setNewRepresentative({ ...newRepresentative, name: e.target.value })}
                        placeholder="Enter representative name"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="repBusinessName">Business Name*</Label>
                    <Input
                        id="repBusinessName"
                        value={newRepresentative.businessName}
                        onChange={e => setNewRepresentative({ ...newRepresentative, businessName: e.target.value })}
                        placeholder="Enter business name"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="repPhone">Phone</Label>
                    <Input
                        id="repPhone"
                        value={newRepresentative.phone}
                        onChange={e => setNewRepresentative({ ...newRepresentative, phone: e.target.value })}
                        placeholder="Enter phone number"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="repEmail">Email</Label>
                    <Input
                        id="repEmail"
                        value={newRepresentative.email}
                        onChange={e => setNewRepresentative({ ...newRepresentative, email: e.target.value })}
                        placeholder="Enter email"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="repAddress">Address</Label>
                    <Input
                        id="repAddress"
                        value={newRepresentative.address}
                        onChange={e => setNewRepresentative({ ...newRepresentative, address: e.target.value })}
                        placeholder="Enter address"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="repRole">Role</Label>
                    <Input
                        id="repRole"
                        value={newRepresentative.role}
                        onChange={e => setNewRepresentative({ ...newRepresentative, role: e.target.value })}
                        placeholder="Enter role"
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={creatingRepresentative}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleCreateRepresentative} disabled={creatingRepresentative}>
                    {creatingRepresentative ? 'Creating...' : 'Create'}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddRepresentativeModal
